<template>
    <b-row>
        <b-col cols="12">
            <div
                class="d-sm-flex justify-content-between align-items-center mb-4"
            >
                <feather
                    type="arrow-left-circle"
                    v-b-popover.hover.top="'Presione esc'"
                    role="button"
                    class="text-secondary"
                    size="2rem"
                    @click="back"
                ></feather>
                <div class="d-flex flex-row">
                    <b-button
                        variant="secondary"
                        :disabled="isLoading"
                        v-b-popover.hover.top="'Presione esc'"
                        size="md"
                        class="mr-4"
                        @click="back"
                    >
                        Cancelar
                    </b-button>

                    <b-button
                        variant="primary"
                        :disabled="
                            isLoading ||
                            read_only ||
                            !permisos.includes('cuenta-fe-editar') ||
                            !permisos.includes('cuenta-fe-crear')
                        "
                        size="md"
                        class="d-flex align-items-center"
                        v-b-popover.hover.top="
                            'Presione ctrl+shift+s o cmd+shift+s'
                        "
                        @click="save"
                    >
                        <feather
                            type="save"
                            size="1rem"
                            class="mr-2 text-blue-active"
                        />
                        <span
                            v-if="isLoading"
                            class="d-sm-flex align-items-center justify-content-center"
                        >
                            <b-spinner small></b-spinner>
                            <span class="ml-2">Guardando...</span>
                        </span>
                        <span v-else>Guardar</span>
                    </b-button>
                </div>
            </div>
        </b-col>
        <b-col
            cols="12"
            lg="12"
            class="d-flex align-items-stretch"
            style="min-height: 70vh"
        >
            <b-card class="mb-4 w-100">
                <div>
                    <b-form class="p-5">
                        <div class="d-flex">
                            <div>
                                <h3 class="mb-2">
                                    Datos del envío de facturación electrónica
                                </h3>
                                <div class="text-gray mb-5">
                                    Por favor registre los datos del envío de
                                    facturación electrónica
                                </div>
                            </div>
                        </div>
                        <b-row v-hotkey="keymap">
                            <b-col cols="12" sm="6">
                                <b-form-group>
                                    <label for="username">Usuario</label>
                                    <b-form-input
                                        id="username"
                                        type="text"
                                        v-model="$v.form.username.$model"
                                        :disabled="
                                            read_only ||
                                            !permisos.includes(
                                                'cuenta-fe-editar'
                                            ) ||
                                            !permisos.includes(
                                                'cuenta-fe-crear'
                                            )
                                        "
                                        :state="validateState('username')"
                                    >
                                    </b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.form.username.$anyError"
                                    >
                                        ({{ $v.form.username.$model.length }}
                                        /
                                        {{
                                            $v.form.username.$params.maxLength
                                                .max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.form.username.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.form.username.$params.maxLength
                                                .max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.form.username.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                    <!-- <div
                                        class="invalid-field mt-1"
                                        v-if="$v.form.username.$error"
                                    >
                                        Campo requerido
                                    </div> -->
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6">
                                <label for="password">Contraseña</label>
                                <b-input-group>
                                    <b-form-input
                                        id="password"
                                        :type="showPwd ? 'text' : 'password'"
                                        v-model="$v.form.password.$model"
                                        :disabled="
                                            read_only ||
                                            !permisos.includes(
                                                'cuenta-fe-editar'
                                            ) ||
                                            !permisos.includes(
                                                'cuenta-fe-crear'
                                            )
                                        "
                                        :state="validateState('password')"
                                    >
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-button
                                            size="sm"
                                            class="d-flex align-items-center"
                                            @click="showPwd = !showPwd"
                                            :disabled="
                                                read_only ||
                                                !permisos.includes(
                                                    'cuenta-fe-editar'
                                                ) ||
                                                !permisos.includes(
                                                    'cuenta-fe-crear'
                                                )
                                            "
                                        >
                                            <feather
                                                type="eye"
                                                size="1rem"
                                            ></feather>
                                        </b-button>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback
                                        v-if="!$v.form.password.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.form.password.$params.maxLength
                                                .max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.form.password.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-input-group>
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.form.password.$anyError"
                                >
                                    ({{ $v.form.password.$model.length }}
                                    /
                                    {{
                                        $v.form.password.$params.maxLength.max
                                    }})
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-card>
        </b-col>
        <b-col cols="12">
            <div class="float-right">
                <div class="d-flex flex-row">
                    <b-button
                        variant="secondary"
                        :disabled="isLoading"
                        v-b-popover.hover.top="'Presione esc'"
                        size="md"
                        class="mr-4"
                        @click="back"
                    >
                        Cancelar
                    </b-button>

                    <b-button
                        variant="primary"
                        :disabled="
                            isLoading ||
                            read_only ||
                            !permisos.includes('cuenta-fe-editar') ||
                            !permisos.includes('cuenta-fe-crear')
                        "
                        size="md"
                        class="d-flex align-items-center"
                        v-b-popover.hover.top="
                            'Presione ctrl+shift+s o cmd+shift+s'
                        "
                        @click="save"
                    >
                        <feather
                            type="save"
                            size="1rem"
                            class="mr-2 text-blue-active"
                        />
                        <span
                            v-if="isLoading"
                            class="d-sm-flex align-items-center justify-content-center"
                        >
                            <b-spinner small></b-spinner>
                            <span class="ml-2">Guardando...</span>
                        </span>
                        <span v-else>Guardar</span>
                    </b-button>
                </div>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { maxLength, required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import {
    addListenerCommands,
    removeListenerCommands,
    compareObjects
} from '@/utils/others'
import services from '@/boot/axios'

const { API } = services

const defaultForm = () =>
    JSON.parse(
        JSON.stringify({
            username: '',
            password: '',
            empresaId: null
        })
    )

export default {
    name: 'envioFacturacion',
    mixins: [validationMixin],
    data: () => ({
        form: defaultForm(),
        formCopy: defaultForm(),
        isLoading: false,
        read_only: false,
        isSaved: true,
        showPwd: false
    }),
    watch: {
        form: {
            handler(newValue) {
                this.isSaved = compareObjects(this.formCopy, newValue)
            },
            deep: true
        }
    },
    mounted() {
        addListenerCommands(this)
        this.read_only = this.$route.meta.read_only
        this.getFormByEmpresaId(this.getUltimaEmpresa.id)
    },
    beforeDestroy() {
        removeListenerCommands(this)
    },
    beforeRouteLeave(to, from, next) {
        if (this.isSaved) {
            next()
        } else {
            this.$bvModal
                .msgBoxConfirm(
                    `
        Este formulario contiene información que no ha sido guardada,
        si continua con esta acción no se guardarán los cambios, desea continuar con esta acción?`,
                    {
                        title: 'Advertencia!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Continuar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2 d-flex justify-content-between',
                        hideHeaderClose: false,
                        centered: true,
                        headerBgVariant: 'danger',
                        headerClass: 'modal-header'
                    }
                )
                .then((value) => {
                    if (value) {
                        next()
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    validations: {
        form: {
            username: {
                required,
                maxLength: maxLength(50)
            },
            password: {
                required,
                maxLength: maxLength(50)
            }
        }
    },
    methods: {
        getFormByEmpresaId(empresaId) {
            this.isLoading = true
            API.POST({
                url: 'cuenta-fe/all',
                data: {
                    empresaId
                }
            })
                .then((response) => {
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    this.isLoading = false
                    if (status === 'ok') {
                        const { id, username, password } = dato
                        this.form = { id: Number(id), username, password }
                        this.formCopy = { id: Number(id), username, password }
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    this.isLoading = false
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        save() {
            const valid = !this.$v.form.$invalid
            if (valid) {
                this.isLoading = true
                const p_opc = this.form.id ? 'UPDATE' : 'INSERT'
                API.POST({
                    url: 'cuenta-fe/crud',
                    data: {
                        p_datajson: {
                            ...this.form,
                            empresaId: this.getUltimaEmpresa.id
                        },
                        p_opc,
                        p_auditoriajson: this.auditoriajson
                    }
                })
                    .then((response) => {
                        const {
                            data: {
                                status: { status, mensaje, mensaje_exception }
                            }
                        } = response
                        this.isLoading = false
                        if (status === 'ok') {
                            this.isSaved = true
                            this.$bvModal.msgBoxOk(
                                this.form.id
                                    ? 'Actualizado correctamente'
                                    : 'Insertado correctamente',
                                {
                                    title: 'Exito!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'success',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'success',
                                    headerClass: 'modal-header'
                                }
                            )
                        } else {
                            this.$bvModal
                                .msgBoxOk(
                                    mensaje ||
                                        mensaje_exception ||
                                        'Ha ocurrido un error!',
                                    {
                                        title: 'Error!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'error',
                                        okTitle: 'Aceptar',
                                        cancelTitle: 'Cancelar',
                                        footerClass: 'p-2',
                                        hideHeaderClose: false,
                                        centered: true,
                                        headerBgVariant: 'error',
                                        headerClass: 'modal-header'
                                    }
                                )
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false
                        const { message } = error
                        this.$bvModal
                            .msgBoxOk(message || 'Ha ocurrido un error!', {
                                title: 'Error!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'error',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'error',
                                headerClass: 'modal-header',
                                noStacking: true
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
            } else {
                this.$v.form.$touch()
            }
        },
        back() {
            this.$router.back()
        },
        validateState(key) {
            const { $dirty, $error } = this.$v.form[key]
            return $dirty ? !$error : null
        }
    },
    computed: {
        keymap() {
            if (
                navigator.platform.toLowerCase().includes('mac') ||
                navigator.platform.toLowerCase().includes('macintosh')
            ) {
                return {
                    'command+shift+s': this.read_only ? () => {} : this.save,
                    esc: this.back
                }
            } else if (
                navigator.platform.toLowerCase().includes('win') ||
                navigator.platform.toLowerCase().includes('windows')
            ) {
                return {
                    'ctrl+shift+s': this.read_only ? () => {} : this.save,
                    esc: this.back
                }
            } else {
                return {}
            }
        },
        auditoriajson() {
            const json = { ...this.getAuditoriaJson, modulo_id: 21 }
            return json
        },
        permisos() {
            return this.getPermisos.permisos_authorities
        },
        ...mapGetters('usuario', [
            'getUserData',
            'getAuditoriaJson',
            'getPermisos'
        ]),
        ...mapGetters('empresas', ['getUltimaEmpresa'])
    }
}
</script>
